import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import AccountIcon from '@material-ui/icons/AccountBalanceOutlined';
import BaseDialog from '../BaseDialog/BaseDialog';
import ReplaceArrangementTerms from '../Replace/ReplaceArrangementTerms/ReplaceArrangementTerms.js';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ArrangementsInfoDialog extends React.Component {
  generateDialogContent() {
    const { classes, termsAction } = this.props;
    return (
      <React.Fragment>
        <Typography
          component="div"
          className={`${classes.documentStyle} ${classes.dialogContent}`}
          dangerouslySetInnerHTML={{
            __html: portalContent.NEW_ARRANGEMENTS_MODAL_BLURB,
          }}
        />
        <Divider />
        <br />
        <Typography
          component="div"
          className={`${classes.documentStyle} ${classes.dialogContent}`}
        >
          <ReplaceArrangementTerms
            content={portalContent.NEW_ARRANGEMENTS_MODAL_BLURB_2}
            action={termsAction}
          />
        </Typography>
      </React.Fragment>
    );
  }

  render() {
    const { theme, open, toggleAction, nextAction } = this.props;

    return (
      <BaseDialog
        open={open}
        largeTitle={true}
        title={getString('rentArrangements', 'NEW_ARRANGEMENT_DIALOG_TITLE')}
        content={this.generateDialogContent()}
        buttonAction={nextAction}
        buttonLabel={getString('app', 'NEXT_LABEL')}
        secondaryButtonAction={toggleAction}
        secondaryButtonLabel={getString('app', 'CANCEL_LABEL')}
        icon={AccountIcon}
        iconColour={theme.palette.custom.accounts}
        contentWrap={false}
        inlineTitle={true}
      />
    );
  }
}

ArrangementsInfoDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  toggleAction: PropTypes.func.isRequired,
  nextAction: PropTypes.func.isRequired,
  termsAction: PropTypes.func.isRequired,
};

ArrangementsInfoDialog.defaultProps = {};

export default withStyles(styles, { withTheme: true })(ArrangementsInfoDialog);
